import { SPONSORED_TEXT_VIEW } from '../actions/types';

export const triggerSponsoredTextOffersViewed = (length) => ({
  type: SPONSORED_TEXT_VIEW,
  length,
});
